import { colors } from '@kmns-internal/furikake/tokens'
import { primitiveColors } from 'src/features/theme/primitiveColors'

/**
 * @deprecated 🚨このファイルは deprecated です。新規実装・移行時は `@kmns-internal/furikake/tokens` を import して使用してください。
 * 代表的な置き換え例:
 * - 色指定の定数: `Primary` / `Danger` など → `colors.primary.main` / `colors.error.main` など
 * - 固定値の定数: `White` など → `white`, `colors.white`
 *
 * 例:
 * - `Primary` → `colors.primary.main`
 * - `Info` → `colors.info.main`
 * - `Success` → `colors.success.main`
 * - `Danger` → `colors.error.main`
 * - `Warning` → `colors.warning.main`
 * - `White` → `colors.white`
 * - `Default` → `colors.text.primary`
 *
 * ※ RowActionButton などには使用されています
 */

export const Default = primitiveColors.gray._6 // #7f8c9d
export const Primary = primitiveColors.indigo._8 // #3b5bdb
export const Info = primitiveColors.indigo._6 // #4c6ef5
export const Success = primitiveColors.green._6 // #40c057
export const Danger = primitiveColors.red._6 // #fa5252
export const Warning = primitiveColors.yellow._6 // #fab005
export const White = primitiveColors.white // #ffffff
export const Black = primitiveColors.gray._9 // #1e242c
export const Gray = primitiveColors.gray._6 // #7f8c9d
export const DarkGray = primitiveColors.gray._7 // #434e5d
export const Disable = primitiveColors.gray._6 // #7f8c9d
export const AppBackgroundColor = primitiveColors.gray._1 // #eff2f7
export const ModalDeleteButtonColor = primitiveColors.red._6 // #fa5252
export const PlaceholderText = 'rgba(0, 0, 0, 0.25)'

// Table
export const TableBorderColor = primitiveColors.gray._3

// Border
export const BorderColor = primitiveColors.gray._4

// ラベル
export const IndicatedIssueLabelColor = primitiveColors.indigo._1

// 表形式ラベル
export const GridTemplateLabelColor = primitiveColors.cyan._1

// レポート一覧画面
export const ReportTableDateColumnColor = primitiveColors.gray._2

// レポート結果画面/テーブル
export const ScrollBarThumbColor = primitiveColors.gray._4
export const RequiredBadgeColor = primitiveColors.red._6
// レポート結果画面/テーブル/背景色
export const CellDefaultBackgroundColor = primitiveColors.white
export const CellInvalidBackgroundColor = primitiveColors.red._0
export const CellFixedBackgroundColor = primitiveColors.gray._1
// レポート結果画面/テーブル/文字色
export const CellDefaultFontColor = primitiveColors.gray._9
export const CellInvalidFontColor = primitiveColors.red._6
export const CellUnAnsweredFontColor = colors.text.disabled
export const CellUnAnsweredVariableFontColor = primitiveColors.gray._6

// TemplateEdit
export const SectionColor = primitiveColors.white
export const SectionBackgroundColor = primitiveColors.gray._7
export const DisabledTableCellBackgroundColor = primitiveColors.gray._2
export const TableHeaderBackgroundColor = primitiveColors.gray._0

// TemplateEdit内のIcon
export const DeleteIconColor = primitiveColors.red._6
export const BranchesIconColor = primitiveColors.indigo._8
export const DragButtonColor = primitiveColors.gray._7

// 取り込み項目のセルエラー時の背景色
export const GridVariableCellErrorBackgroundColor = primitiveColors.red._2

export const Blue0 = primitiveColors.blue._0
export const Blue6 = primitiveColors.blue._6 // 旧プライマリカラー #10a8eb

// Gray
export const Gray1 = primitiveColors.gray._1
export const Gray5 = primitiveColors.gray._5
export const Gray6 = primitiveColors.gray._6
export const ColorTextTertiary = primitiveColors.gray._9 + '73'
export const ColorTextSecondary = primitiveColors.gray._9 + 'a6'

// Indigo
export const Indigo0 = primitiveColors.indigo._0
export const Indigo7 = primitiveColors.indigo._7
